module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/mlb/survive_wt-96a3ee9dd894eca65fae9add137f6193.svg";